import type { ResourceSource } from "solid-js";
import { createResource } from "solid-js";
import { extractFilename } from "./uploadUtil";
import { useClient } from "../state/client";

export const createFileResource = (resourceSource: ResourceSource<string>) => {
  const client = useClient();

  return createResource(resourceSource, async (uri): Promise<{ data: string; filename: string | undefined } | null> => {
    const response = await client.get(uri, {
      responseType: "blob",
    });

    const filename = extractFilename(response);

    return { data: URL.createObjectURL(response.data), filename };
  });
};
